
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1977_3688)"}},[_c('path',{attrs:{"d":"M17.024 2.923h-1.949a.977.977 0 00-.974.975c0 .536.438.974.974.974h1.949a.977.977 0 00.974-.974.977.977 0 00-.974-.975zM17.024 7.795h-1.949a.977.977 0 00-.974.975c0 .536.438.974.974.974h1.949a.977.977 0 00.974-.974.977.977 0 00-.974-.975zM17.024 12.668h-1.949a.977.977 0 00-.974.974c0 .536.438.974.974.974h1.949a.977.977 0 00.974-.974.977.977 0 00-.974-.974zM10.203 0H5.331a.977.977 0 00-.974.974V8.37L.985 11.742a3.394 3.394 0 000 4.784 3.36 3.36 0 002.397.994 3.36 3.36 0 002.397-.994l5.116-5.115a.964.964 0 00.283-.692V.974A.977.977 0 0010.203 0zM9.23 1.949v1.949H6.305v-1.95H9.23zm-6.86 13.194a1.435 1.435 0 010-2.037l.039-.039 2.036 2.037-.039.039c-.545.545-1.49.545-2.027 0h-.01zm3.45-1.423l-2.037-2.037 2.231-2.231a.964.964 0 00.283-.692V5.837h2.923v4.472l-3.41 3.41h.01z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1977_3688"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    